import axios from 'axios';
import BaseApi from './base';
import {
    COUNTRIES,
    TEL_CODES
} from '../constants/api';

const BASIC_TOKEN = process.env.VUE_APP_BASIC_TOKEN;

export default class extends BaseApi {
    static get() {
        return axios.get(COUNTRIES);
    }

    static getTelCodes() {
        return axios.get(TEL_CODES, {
            headers: {
                'Authorization': `Basic ${BASIC_TOKEN}`,
            },
        });
    }
}